import React, { Component } from 'react';


class Userexist extends Component {

    render() {
        return (
            <div className="container">
                <h1 className="text-center">This user does not exist!</h1>
            </div>
        );
    }
}

export default Userexist;



// WEBPACK FOOTER //
// ./src/Errorpages/Userexist.js